export default __webpack_public_path__ + "static/6_36-1c8f2194375a9fda930e223d72646724.png";